/* eslint-disable */
import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import './projects.scss';
import {
  addRecognition,
  deleteRecognition,
  getRecognition,
} from '../../../Api/request/userRoles';
import UseAxios from '../../../Api/http/http';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import ProjectAccordion from './project-accordian';
import RecognitionModal from './recognition-model';
import { getProjectDetails } from '../../../Api/request/project';
import PropTypes from 'prop-types';
import AddButton from '../../../Assets/images/svg/addbutton.svg';
import RecognitionItem from './recognition-item';
import { AuthContext } from '../../../Contexts/AuthContext';
import NoEmployeeDetails from '../EmployeeAchievementDetails/noEmployeeDetails';
import { PROJECTS_PROFILE, SKILL_CERT_PROFILE } from '../../../Constants/strings';
import DeleteDialog from './deletefeedback';
import { MODULE_NAMES } from '../../../Constants/modules';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const ProjectsPage = ({userId, userEmailId, userName}) => {
  const [recognitionModalOpen, setRecognitionModalOpen] = useState(false);
  const [newRecognition, setNewRecognition] = useState({
    type: 'Star of the month',
    feedback: '',
    year: '',
    month: '',
    clientName: '',
    date: '',
  });
  const { snackbarOpen } = useSnackbar();
  const [recognitions, setRecognitions] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [projects, setProjects] = useState([]);
  const [showPastDetails, setShowPastDetails] = useState(false);
  const [expandedOngoing, setExpandedOngoing] = useState(false);
  const [expandedPrevious, setExpandedPrevious] = useState(false);
  const { userProfile } = useContext(AuthContext);
  const permissions = userProfile?.permissions?.[MODULE_NAMES.CONFIGURATION_USER] || [];

  const hasAccess = (action) => {
    return permissions.includes(action);
  };

  useEffect(() => {
    fetchProjectDetails(userId);
  }, [userId]);
  const fetchProjectDetails = async (userId) => {

    try {
      const response = await UseAxios(getProjectDetails(userId));
      setProjects(response.data);
    } catch (error) {
      console.error('Error fetching users project details:', error);
      snackbarOpen(`${PROJECTS_PROFILE.OOPS_TRY_AGAIN}`, 'warning');
    }
  };
  const initialRecognitionState = useMemo(
    () => ({
      type: 'Star of the month',
      feedback: '',
      year: '',
      month: '',
      clientName: '',
      date: '',
    }),
    [],
  );

  const togglePastDetails = () => {
    setShowPastDetails(!showPastDetails);
  };

  const handleChangeOngoing = useCallback((panel) => (event, isExpanded) => {
    setExpandedOngoing(isExpanded ? panel : false);
  }, []);

  const handleChangePrevious = useCallback((panel) => (event, isExpanded) => {
    setExpandedPrevious(isExpanded ? panel : false);
  }, []);

  const openRecognitionModal = useCallback(() => {
    setNewRecognition(initialRecognitionState);
    setRecognitionModalOpen(true);
  }, [initialRecognitionState]);

  const closeRecognitionModal = useCallback(() => {
    setRecognitionModalOpen(false);
    setNewRecognition(initialRecognitionState);
  }, [initialRecognitionState]);

  const handleRecognitionChange = useCallback((e) => {
    const { name, value } = e.target;
    setNewRecognition((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  const handleOpenDialog = useCallback((item) => {
    setSelectedItem(item);
    setIsDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setSelectedItem(null);
    setIsDialogOpen(false);
  }, []);

  const handleGetActions = useCallback(async () => {
    const token = localStorage.getItem('userRolesToken');
    try {
      const response = await UseAxios(getRecognition(token, userId));
      if (response?.data?.recognitions) {
        setRecognitions(response.data.recognitions);
      }
    } catch (error) {
      snackbarOpen(`${PROJECTS_PROFILE.OOPS_TRY_AGAIN}`, 'warning');
    }
  }, []);

  useEffect(() => {
    handleGetActions();
  }, [handleGetActions]);

  const handleDeleteAction = useCallback(
    async (item) => {
      const token = localStorage.getItem('userRolesToken');
      try {
        const response = await UseAxios(
          deleteRecognition(token, item.recognition_id),
        );
        if (response && response.data.status === 200) {
          snackbarOpen(`${PROJECTS_PROFILE.FEEDBACK_DELETED}`, 'success');
          await handleGetActions();
        }
      } catch (error) {
        snackbarOpen(
          `${PROJECTS_PROFILE.TECHNICAL_ERROR}`,
          'warning',
        );
      }
      handleCloseDialog();
    },
    [snackbarOpen, handleGetActions, handleCloseDialog],
  );

  const saveRecognition = useCallback(async () => {
    if (!newRecognition.feedback.trim()) {
      snackbarOpen(`${PROJECTS_PROFILE.FEEDBACK_REQUIRED}`, 'warning');
      return;
    }
    if (!newRecognition.date && newRecognition.type === 'Client appreciation') {
      snackbarOpen(`${PROJECTS_PROFILE.CLIENT_DATE_REQUIRED}`, 'warning');
      return;
    }
    if (!newRecognition.clientName.trim() && newRecognition.type === 'Client appreciation') {
      snackbarOpen(`${PROJECTS_PROFILE.CLIENT_NAME_REQUIRED}`, 'warning');
      return;
    }
    const isStarOfTheMonth = newRecognition.type === 'Star of the month';

    // Payload for Star of the Month
    const starOfTheMonthPayload = {
      user_id: userId,
      user_name: userName,
      user_email: userEmailId,
      recognition_type: 'Star of the month',
      feedback: newRecognition.feedback,
      date: null,
      client_name: null,
      month: monthNames.indexOf(newRecognition.month) + 1 || null,
      year: newRecognition.year || null,
      last_updated_by: userProfile?.user_name,
    };

    // Payload for Client Appreciation
    const clientAppreciationPayload = {
      user_id: userId,
      recognition_type: 'Client appreciation',
      feedback: newRecognition.feedback,
      date: newRecognition.date,
      client_name: newRecognition.clientName,
      month: null,
      year: null,
      last_updated_by: userProfile?.user_name,
    };

    const payload = isStarOfTheMonth ? starOfTheMonthPayload : clientAppreciationPayload;

    const token = localStorage.getItem('userRolesToken');
    if (!token) {
      return;
    }
    try {
      const response = await UseAxios(addRecognition(token, payload));
      if (response && response.data.status === 200) {
        snackbarOpen(`${PROJECTS_PROFILE.RECOGNITION_ADDED}`, 'success');
        await handleGetActions();
        closeRecognitionModal();
      }
    } catch (error) {
      snackbarOpen(`${PROJECTS_PROFILE.TECHNICAL_ERROR}`, 'warning');
    }
  }, [newRecognition, snackbarOpen, handleGetActions, closeRecognitionModal]);

  return (
    <div className="projects-page">
      <div className="projects-page-outer-div">
        <div className="projects-page-heading-div">
          <div className="projects-heading-name">{PROJECTS_PROFILE.PROJECTS}</div>
          <div className="projects">
            <div className="heading">{PROJECTS_PROFILE.TOTAL} </div>
            <div className="total">{projects.totalProjects}</div>
            <div className="separator">|</div>
            <div className="heading">{PROJECTS_PROFILE.ONGOING} </div>
            <div className="total">{projects.ongoingProjects}</div>
          </div>
        </div>
        <div className="project-details-accordion">
          {projects.totalProjects == 0 ? (
            <NoEmployeeDetails
              message={SKILL_CERT_PROFILE.NO_DATA}
              noEmployeeCss="no-project-css"
            />
          ) : (
            <>
              {projects?.onGoingProjectDetails?.map((project, index) => (
                <ProjectAccordion
                  key={project.projectName}
                  project={project}
                  index={index}
                  expanded={expandedOngoing}
                  handleChange={handleChangeOngoing}
                  recognitions={recognitions}
                  monthNames={monthNames}
                  openRecognitionModal={openRecognitionModal}
                  handleOpenDialog={handleOpenDialog}
                  selectedItem={selectedItem}
                  setIsDialogOpen={setIsDialogOpen}
                  isDialogOpen={isDialogOpen}
                  handleCloseDialog={handleCloseDialog}
                  handleDeleteAction={handleDeleteAction}
                />
              ))}
            </>
          )}
        </div>
      <div className={showPastDetails ? 'view-past-details' : 'view-past-details-active'}>
        <button onClick={togglePastDetails} className="view-past-details-button">
        {!showPastDetails? 'View Past Projects' : 'Hide Past Projects'}
      </button>
      </div>
      {showPastDetails && (
        <div className="project-details-accordion">
          {projects?.previousProjectDetails?.length === 0 ? (
            <NoEmployeeDetails
              message={SKILL_CERT_PROFILE.NO_PREVIOUS_PROJECTS}
              noEmployeeCss="no-project-css"
            />
          ) : (
            <>
              {projects?.previousProjectDetails?.map((project, index) => (
                <ProjectAccordion
                  key={project.projectName}
                  project={project}
                  index={index}
                  expanded={expandedPrevious}
                  handleChange={handleChangePrevious}
                  recognitions={recognitions}
                  monthNames={monthNames}
                  openRecognitionModal={openRecognitionModal}
                  handleOpenDialog={handleOpenDialog}
                  selectedItem={selectedItem}
                  setIsDialogOpen={setIsDialogOpen}
                  handleCloseDialog={handleCloseDialog}
                  handleDeleteAction={handleDeleteAction}
                  isPreviousProject={true}
                />
              ))}
            </>
          )}
        </div>
      )}
        <RecognitionModal
          isOpen={recognitionModalOpen}
          newRecognition={newRecognition}
          monthNames={monthNames}
          handleRecognitionChange={handleRecognitionChange}
          closeRecognitionModal={closeRecognitionModal}
          saveRecognition={saveRecognition}
        />
      </div>
      <div className="recognitions">
        <div className="recognitions-header-div">
          <h3>{PROJECTS_PROFILE.RECOGNITIONS}</h3>
          {hasAccess('create') && (
            <button onClick={openRecognitionModal}>
              <img src={AddButton} alt="Add recognition" />
            </button>)}
        </div>
        <div className='recognition-item-outer'>
          { recognitions.length == 0 ? (
            <NoEmployeeDetails message={SKILL_CERT_PROFILE.NO_DATA} noEmployeeCss="no-recognition-css"/>
          ) : (
            recognitions.map((recognition) => (
              <RecognitionItem
                key={recognition.recognition_id}
                recognition={recognition}
                monthNames={monthNames}
                handleOpenDialog={handleOpenDialog}
              />
            ))
          )}
        </div>
      </div>
      <DeleteDialog
        selectedItem={selectedItem}
        setIsDialogOpen={setIsDialogOpen}
        handleCloseAction={handleCloseDialog}
        handleDeleteAction={handleDeleteAction}
      />
    </div>
  );
};

ProjectsPage.propTypes = {
  userId: PropTypes.string.isRequired,
  userEmailId: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};

export default ProjectsPage;
